// @vue/component

export default {
  name: 'HelpPageSupervisor',
  props: {
    supervisor: Object,
  },
};
